import React from "react";
import { Link } from "wouter";
import { siteConfig } from "@/data/site";

export default function TermsOfUse() {
  return (
    <article className="legal-page">
      <header className="legal-page__header">
        <p className="breadcrumb"><Link href="/">Home</Link><span aria-hidden="true">/</span><span>Terms of Use</span></p>
        <span className="kicker">Website terms</span>
        <h1>Terms of Use</h1>
        <p>These terms govern use of {siteConfig.domain}. By using the website, you agree to these terms and the linked Privacy Policy.</p>
        <p className="legal-page__updated">Last updated August 9, 2026</p>
      </header>

      <div className="legal-page__content">
        <section>
          <h2>Website information</h2>
          <p>Website content is provided for general commercial restroom planning and product-selection information. It is not architectural, engineering, accessibility, code, or legal advice. Project requirements, dimensions, substrates, mounting conditions, product availability, and applicable codes must be verified for the specific project by qualified parties.</p>
        </section>

        <section>
          <h2>Quotes and orders</h2>
          <p>A website submission is a request for information or pricing, not an accepted order or binding commitment. Pricing, availability, lead times, freight, installation scope, taxes, payment terms, substitutions, and final specifications are governed by the written quote, order acknowledgment, contract, or other signed project documents issued for the transaction.</p>
        </section>

        <section>
          <h2>Files and submissions</h2>
          <p>You may submit only information and files you are authorized to share. Do not upload malicious code, confidential information unrelated to the requested work, or content that infringes another party’s rights. You remain responsible for the accuracy and completeness of plans, measurements, quantities, product selections, and project details you provide.</p>
        </section>

        <section>
          <h2>Google reviews and third-party services</h2>
          <p>The website may display rating and review content supplied through Google Maps Platform. Reviews remain Google and reviewer content, are shown in Google’s returned relevance order, and do not represent statements written or edited by Partition Stalls. Google Maps content is governed by the <a href="https://cloud.google.com/maps-platform/terms" target="_blank" rel="noopener noreferrer">Google Maps Platform Terms</a> and the <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google Terms of Service</a>. Other third-party links and services are governed by their respective terms.</p>
        </section>

        <section>
          <h2>Acceptable use</h2>
          <p>You may not interfere with website operation, bypass security or rate limits, submit fraudulent requests, attempt unauthorized access, copy the site for unlawful use, or use automated means to burden the service. We may restrict access when reasonably necessary to protect the website, customers, or business operations.</p>
        </section>

        <section>
          <h2>Ownership</h2>
          <p>The website design, original copy, graphics, and software are owned by or licensed to Partition Stalls, except for third-party names, logos, product information, maps, reviews, and other content identified with their respective owners.</p>
        </section>

        <section>
          <h2>Disclaimers and responsibility</h2>
          <p>The website is provided on an “as available” basis. To the extent permitted by applicable law, Partition Stalls disclaims warranties arising solely from website use and is not responsible for interruption, third-party content, or decisions made without verification of project-specific requirements. Nothing in these terms limits responsibility that cannot lawfully be limited.</p>
        </section>

        <section>
          <h2>Changes and contact</h2>
          <p>We may update these terms when the website, services, or legal requirements change. The updated date will appear above. Questions may be sent to <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>.</p>
        </section>
      </div>
    </article>
  );
}
